import React from 'react'
import LoadingTableComponent from './utilityComponents/LoadingTableComponent'
import { NavLink } from 'react-router-dom'
import { TimeAndDateFormat } from '../utils/TimeAndDateFormat'

const AnnouncementsTable = ({ data, limit, loading, deleteAnnouncement, toggleAnnouncementStatus }) => {

    const getPriorityColor = (priority) => {
        switch (priority) {
            case 'urgent': return 'bg-red-500 text-white';
            case 'high': return 'bg-orange-500 text-white';
            case 'medium': return 'bg-yellow-500 text-black';
            case 'low': return 'bg-green-500 text-white';
            default: return 'bg-gray-500 text-white';
        }
    };

    const getTypeColor = (type) => {
        switch (type) {
            case 'error': return 'bg-red-100 text-red-800';
            case 'warning': return 'bg-yellow-100 text-yellow-800';
            case 'success': return 'bg-green-100 text-green-800';
            case 'info': return 'bg-blue-100 text-blue-800';
            case 'promotion': return 'bg-purple-100 text-purple-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    };

    return (
        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-[black] text-[white]">
                <tr>
                    <th className="px-4 py-3">Title</th>
                    <th className="px-4 py-3">Type</th>
                    <th className="px-4 py-3">Priority</th>
                    <th className="px-4 py-3">Target Audience</th>
                    <th className="px-4 py-3">Active</th>
                    <th className="px-4 py-3">Start Date</th>
                    <th className="px-4 py-3">End Date</th>
                    <th className="px-4 py-3">Actions</th>
                </tr>
            </thead>
            {loading ? (
                <LoadingTableComponent cols={8} />
            ) : (
                data?.length > 0 && data.map((announcement) => (
                    <tbody key={announcement._id}>
                        <tr className="bg-white border-b-[#CCCCCC] border-b-[0.5px] py-4">
                            <td className="px-4 w-fit max-w-[200px]">
                                <div className="truncate" title={announcement.title}>
                                    {announcement.title}
                                </div>
                            </td>

                            <td className="px-4 w-fit">
                                <span className={`px-2 py-1 rounded-full text-xs capitalize ${getTypeColor(announcement.type)}`}>
                                    {announcement.type}
                                </span>
                            </td>

                            <td className="px-4 w-fit">
                                <span className={`px-2 py-1 rounded-full text-xs capitalize ${getPriorityColor(announcement.priority)}`}>
                                    {announcement.priority}
                                </span>
                            </td>

                            <td className="px-4 w-fit capitalize">
                                {announcement.targetAudience}
                            </td>

                            <td className="px-4 w-fit">
                                <button
                                    onClick={() => toggleAnnouncementStatus(announcement._id)}
                                    className={`px-2 py-1 rounded-full text-xs ${
                                        announcement.isActive
                                            ? 'bg-green-100 text-green-800'
                                            : 'bg-gray-100 text-gray-800'
                                    }`}
                                >
                                    {announcement.isActive ? 'Active' : 'Inactive'}
                                </button>
                            </td>

                            <td className="px-4 w-fit min-w-[120px]">
                                {TimeAndDateFormat.getFormattedDate(announcement.startDate)}
                            </td>

                            <td className="px-4 w-fit min-w-[120px]">
                                {announcement.endDate
                                    ? TimeAndDateFormat.getFormattedDate(announcement.endDate)
                                    : 'No end date'
                                }
                            </td>

                            <td className="py-4 px-4 w-fit flex gap-2">
                                <NavLink
                                    to={`/announcements/edit/${announcement._id}`}
                                    className="p-1 px-3 rounded-[6px] border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white"
                                >
                                    Edit
                                </NavLink>
                                <button
                                    onClick={() => deleteAnnouncement(announcement._id)}
                                    className="p-1 px-3 rounded-[6px] border border-red-500 text-red-500 hover:bg-red-500 hover:text-white"
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    </tbody>
                ))
            )}
            {data?.length === 0 && !loading && (
                <tbody>
                    <tr>
                        <td colSpan="8" className="px-4 py-8 text-center text-gray-500">
                            No announcements found
                        </td>
                    </tr>
                </tbody>
            )}
        </table>
    )
}

export default AnnouncementsTable
